module.exports = __webpack_public_path__ + "empresariayungol.svg?ab2d4ffbb45bdf345267ff0f5afb1f60";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresariayungol.svg
// module id = 463
// module chunks = 0